import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { QUERY_KEYS } from 'services/api/constants';
import { getPublicSiteHost } from 'services/api/epdLibraryApi';
import { Container } from 'styles/Styles.styled';

const EmbeddedEpdLibrary: React.FC<RouteComponentProps> = ({ location }) => {
  const scriptContainer = useRef<HTMLDivElement | null>(null);
  const [hasError, setHasError] = React.useState<any | null>(null);
  const publicSiteHost = useQuery({
    queryKey: [QUERY_KEYS.PUBLIC_SITE_HOST],
    queryFn: getPublicSiteHost,
  }).data;

  useEffect(() => {
    if (!publicSiteHost) {
      return;
    }

    if (scriptContainer.current == null) {
      return;
    }

    const scheme = publicSiteHost.startsWith('localhost') ? 'http' : 'https';
    const scriptUrl = `${scheme}://${publicSiteHost}/embed/library.js${location.search}`;

    const scriptTag = document.createElement('script');
    scriptTag.src = scriptUrl;
    scriptTag.onerror = () => {
      setHasError(true);
    };
    const div = scriptContainer.current;
    div.appendChild(scriptTag);
    return () => {
      div.removeChild(scriptTag);
    };
  }, [publicSiteHost]);

  if (hasError) {
    return <Container>Failed to execute the iframe loading script. Try checking the Network tab for more info.</Container>;
  }

  return (
    <div
      ref={scriptContainer}
      style={{
        // Account for fixed header height
        marginTop: 80,
      }}
    />
  );
};

export default EmbeddedEpdLibrary;
